module.exports = __webpack_public_path__ + "img/ep-body-cream.bbec2374.jpeg";